module.exports = __webpack_public_path__ + "static/media/next.e2d12e35.svg";